import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "contacts",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "admissions-crm" */ "Admissions/features/CRM/components/ContactDirectory"
    ).then(m => m.default)
  ),
  childRoutes: [
    {
      path: ":viewId",
      component: withAsyncRouteLoading(() =>
        import(
          /* webpackChunkName: "admissions-crm" */ "Admissions/features/CRM/components/ContactView"
        ).then(m => m.default)
      ),
    },
  ],
});
